'use client';

import React from 'react';

interface PriceRangeSliderProps {
  value: number;
  min?: number;
  max: number;
  onChange: (value: number) => void;
  currency?: string;
}

export const PriceRangeSlider: React.FC<PriceRangeSliderProps> = ({
  value,
  min = 0,
  max,
  onChange,
  currency = '$',
}) => {
  const mid = Math.round((min + max) / 2);

  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center text-[10px] font-bold uppercase tracking-wider text-slate-500">
        <span>Precio Máximo</span>
        <span className="text-red-900 font-heading font-extrabold text-xs">
          {currency}{value}
        </span>
      </div>
      <div className="space-y-1">
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="w-full h-1 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-blue-500"
        />
        <div className="flex justify-between text-[9px] text-slate-500 font-bold">
          <span>{currency}{min}</span>
          <span>{currency}{mid}</span>
          <span>{currency}{max}</span>
        </div>
      </div>
    </div>
  );
};
